/**
 * Container Component for Puck Editor
 * 
 * Wrapper dengan padding dan background
 */

import type { ComponentConfig } from '@measured/puck'
import { DropZone } from '@measured/puck'

export interface ContainerProps {
  padding: 'none' | 'small' | 'medium' | 'large' | 'xlarge'
  backgroundColor: string
  maxWidth: 'full' | 'container' | 'narrow'
  centered: boolean
}

const paddingClasses = {
  none: 'p-0',
  small: 'py-4 px-4',
  medium: 'py-8 px-4',
  large: 'py-12 px-4',
  xlarge: 'py-16 px-4',
}

const maxWidthClasses = {
  full: 'max-w-none',
  container: 'max-w-7xl',
  narrow: 'max-w-4xl',
}

export function Container({
  padding,
  backgroundColor,
  maxWidth,
  centered,
}: ContainerProps) {
  return (
    <section
      className={paddingClasses[padding]}
      style={{ backgroundColor: backgroundColor || undefined }}
    >
      <div
        className={`${maxWidthClasses[maxWidth]} ${centered ? 'mx-auto' : ''}`}
      >
        <DropZone zone="container-content" />
      </div>
    </section>
  )
}

export const ContainerConfig: ComponentConfig<ContainerProps> = {
  label: 'Container',
  defaultProps: {
    padding: 'medium',
    backgroundColor: '',
    maxWidth: 'container',
    centered: true,
  },
  fields: {
    padding: {
      type: 'select',
      label: 'Padding',
      options: [
        { label: 'Tidak Ada', value: 'none' },
        { label: 'Kecil', value: 'small' },
        { label: 'Sedang', value: 'medium' },
        { label: 'Besar', value: 'large' },
        { label: 'Ekstra Besar', value: 'xlarge' },
      ],
    },
    backgroundColor: {
      type: 'text',
      label: 'Warna Latar (HEX)',
    },
    maxWidth: {
      type: 'select',
      label: 'Lebar Maksimum',
      options: [
        { label: 'Penuh', value: 'full' },
        { label: 'Container', value: 'container' },
        { label: 'Sempit', value: 'narrow' },
      ],
    },
    centered: {
      type: 'radio',
      label: 'Tengah',
      options: [
        { label: 'Ya', value: true },
        { label: 'Tidak', value: false },
      ],
    },
  },
  render: Container,
}
